module.exports = __webpack_public_path__ + "img/pickPack.2965399a.svg";